module.exports = __webpack_public_path__ + "media/assets/images/dust_icon_black-58ea09054f73084a4a8fca1dbcc38bdf.png";